<template>
  <div class="linkButtonWrapper"
       v-bind:style="style.width + style.backgroundColor" v-on:click="goToPage(goToURL)">
    <div class="titleTextWrapper">
      <div class="titleDiv">
        <span class="title">{{title}}</span>
      </div>
      <div class="textDiv">
        <span class="text">{{text + ''}}</span>
      </div>
    </div>
    <img class="linkImage" v-bind:src="img">
  </div>
</template>

<script>

export default {
  props: {
    title: String,
    text: String,
    imgType: Number,
    goToURL: String
  },
  data () {
    return {
      img: '',
      style: {
        width: '',
        backgroundColor: ''
      }
    }
  },
  methods: {
    goToPage: function (goToUrl) {
      if(this.imgType === 2) {
        // 프리미어의 경우 아직 미구현, 경고창 띄움
        alert('준비중인 서비스입니다.')
      }else {
        this.$router.push(goToUrl)
      }
    }
  },
  created: function () {
    if(this.imgType === 0) {
      this.img = require('@/assets/img/advertise_link_button_img.png')
      this.style.backgroundColor = 'background-color: rgb(0,153,255);'
      this.style.width = 'width: 372px;'
    }else if(this.imgType === 1) {
      this.img = require('@/assets/img/payment_link_button_img.png')
      this.style.backgroundColor = 'background-color: rgb(0,0,0);'
      this.style.width = 'width: 224px;'
    }else if(this.imgType === 2) {
      this.img = require('@/assets/img/premiere_link_button_img.png')
      this.style.backgroundColor = 'background-color: rgb(255,191,96);'
      this.style.width = 'width: 224px;'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
  height: 100%;
  width: auto;
}

.linkButtonWrapper {
  cursor: pointer;
  position: relative;
  display: flex;
  display: -ms-flexbox;
  justify-content:space-between;
  align-items: center;
  border-radius: 20px;
  height: 140px;
  color: white;
  margin: 0px;
}

.titleTextWrapper{
  height: 140px;
  margin-left: 15px;
}

.titleDiv{
  margin-top: 20px;
}

.titleDiv > .title{
  font-size: 18px;
}

.textDiv{
  margin-top: 10px;
}

.textDiv > .text{
  font-size: 11px;
}

.linkImage{
  width: 40%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/linkButton.vue